import { HeaderGeneral } from '@/components/DybrComponents/HeaderGeneral';
import { ServiceBackground } from '@/components/DybrComponents/ServiceBackground';
import { ContentWrapper } from '@/components/DybrComponents/StyledServicePagesElements';
import { JoinRequests } from '@/scenes/Management/Community/JoinRequests';
import { ModerationSettings } from '@/scenes/Management/Community/ModerationSettings';
import { useActiveProfile } from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export function ManageCommunity() {
  const navigate = useNavigate();
  const { activeProfileId } = useActiveProfile();
  const profile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );
  if (!profile.isCommunity) {
    // todo change to управление профилем when it is available
    navigate('/settings');
    return null;
  }

  return (
    <ServiceBackground data-testid="ManageCommunity">
      <HeaderGeneral>
        <h1 data-testid="manage-community-header">управление сообществом</h1>
      </HeaderGeneral>
      <ContentWrapper>
        <ModerationSettings />
        <JoinRequests />
      </ContentWrapper>
    </ServiceBackground>
  );
}
